// extracted by mini-css-extract-plugin
module.exports = {"button":"MidtermGoftinoButton_button__eQync","has-banner":"MidtermGoftinoButton_has-banner__FB4BU","tooltip-goftino":"MidtermGoftinoButton_tooltip-goftino__bTPSt"};